import yup, {
    cardNameValidator,
    arrayValidator,
    integerPositiveValidator,
    integerNegativeAllowedValidator,
    stringValidator,
    booleanValidator,
    statusValidator,
} from '~/utils/validators.yup';

export const schema = () =>
    yup.object({
        name: cardNameValidator(),
        description: stringValidator.max(300).required(),
        addonAttack: integerNegativeAllowedValidator,
        addonDefense: integerNegativeAllowedValidator,
        dvComparedOption: integerPositiveValidator,
        dvComparedValue: integerPositiveValidator,
        addonPoint: integerPositiveValidator,
        pointToSteal: integerPositiveValidator,
        addonMaxHp: integerNegativeAllowedValidator,
        addonRegenHp: integerNegativeAllowedValidator,

        phaseRestrictionOptions: arrayValidator,
        bonusExperience: integerPositiveValidator,
        hasCrit: booleanValidator,

        activeRounds: arrayValidator.min(1, 'at lease one must be checked.'),
        activeTurns: arrayValidator.min(1, 'at lease one must be checked.'),

        boonEffects: statusValidator,
    });
